<script setup lang="ts">
import MoreFilters from '../Filters/MoreFilters.vue'
import StackLayout from '../Layouts/StackLayout.vue'

import type {
    AdvancedFiltersEmits,
    AdvancedFiltersProps
} from '@/types/filters/AdvancedFiltersProps'

defineProps<AdvancedFiltersProps>()
defineEmits<AdvancedFiltersEmits>()
</script>

<template>
    <slot name="export" />
    <StackLayout :gap="8" class="space-between" :direction="filtersDirection" isResponsive>
        <StackLayout direction="column" :gap="8">
            <StackLayout :gap="8" class="full-width align-self-end">
                <slot name="filters" />
            </StackLayout>
            <slot name="secondaryFilters" />
        </StackLayout>
        <MoreFilters
            :hideSortBy="hideSortBy"
            :showAdvancedFilters="showAdvancedFilters"
            :isResponsiveSmallScreen="isResponsiveSmallScreen"
            :keepInRow="keepInRow"
            :orderOptions="orderOptions"
            :sortBy="sortBy"
            @openFilters="$emit('openFilters')"
            @changeSortBy="$emit('changeSortBy', $event)">
            <slot name="moreFilters" />
        </MoreFilters>
    </StackLayout>
</template>
